import Cookies from 'universal-cookie';
import { COOKIE_NAME, MAGNITT_DOMAIN } from './constants';

const cookies = new Cookies();

export const setReduxCookies = (reduxStore) => {
    const hostname = window.location.hostname;
    let cookieOptions = { path: '/', domain: MAGNITT_DOMAIN };
    let cookieExpiry  = null;

    if (hostname == 'localhost') {
        cookieOptions = { path: '/' };
    }

    // If user is loggedin and expiry is already being set
    // Then just take the existing expiry and put it again
    // Otherwise, if there is no expiry which means the function is running for the very first after the login then create a new expiry of 60 days
    if (reduxStore.getState().userReducer && reduxStore.getState().userReducer.is_loggedin) {

        // added try-catch for edge case issue
        // Uncaught TypeError: Cannot read properties of undefined (reading 'tokenExpiresAt')

        try {
            if (cookies.get(COOKIE_NAME) && cookies.get(COOKIE_NAME).tokenExpiresAt) {
                cookieExpiry          = new Date(cookies.get(COOKIE_NAME).tokenExpiresAt);
                cookieOptions.expires = cookieExpiry;
            } else {
                cookieExpiry          = new Date(new Date().getTime() + 60 * 24 * 60 * 60 * 1000);
                cookieOptions.expires = cookieExpiry;
            }
        } catch (err) {
            cookieExpiry          = new Date(new Date().getTime() + 60 * 24 * 60 * 60 * 1000);
            cookieOptions.expires = cookieExpiry;
        }

    }

    const tempCookie = cookies.get(COOKIE_NAME);

    cookies.remove(COOKIE_NAME);

    cookies.set(COOKIE_NAME, JSON.stringify({
        ...tempCookie,
        userReducer: reduxStore.getState().userReducer,
        tokenExpiresAt: cookieExpiry
    }), cookieOptions);
}